enum Element {
  /**
   * Spisová značka
   */
  FILE_NUMBER = 'FILE_NUMBER',

  /**
   * Fyzické uložení
   */
  PHYSICAL_STORAGE = 'PHYSICAL_STORAGE',

  /**
   * Čárový kód
   */
  BAR_CODE = 'BAR_CODE',

  /**
   * Datum vytvoření
   */
  CREATED = 'CREATED',

  /**
   * Datum doručení
   */
  DELIVERY_DATE = 'DELIVERY_DATE',

  /**
   * Došlé číslo
   */
  INCOMING_NUMBER = 'INCOMING_NUMBER',

  /**
   * Agenda
   */
  AGENDA = 'AGENDA',

  /**
   * Stav
   */
  STATE = 'STATE',

  /**
   * Vedoucí rejstříku
   */
  INDEX_USER_ROLE = 'INDEX_USER_ROLE',

  /**
   * Řešitelé
   */
  SOLVER_USER_ROLES = 'SOLVER_USER_ROLES',

  /**
   * Správní rozhodnutí
   */
  ADMINISTRATIVE_DECISION = 'ADMINISTRATIVE_DECISION',

  /**
   * Stížnost
   */
  COMPLAINT = 'COMPLAINT',

  /**
   * Způsob vyřízení
   */
  SETTLEMENT_METHODS = 'SETTLEMENT_METHODS',

  /**
   * Datum vyřízení
   */
  SETTLEMENT_DATE = 'SETTLEMENT_DATE',

  /**
   * Datum uzavření
   */
  CLOSING_DATE = 'CLOSING_DATE',

  /**
   * Běžící lhůty
   */
  RUNNING_DEADLINES = 'RUNNING_DEADLINES',

  /**
   * Poznámky
   */
  NOTES = 'NOTES',

  /**
   * Pisatelé
   */
  WRITERS = 'WRITERS',

  /**
   * Úlohy a lhůty
   */
  TASKS_AND_DEADLINES = 'TASKS_AND_DEADLINES',
  TASKS = 'TASKS',

  /**
   * Koncepty
   */
  DRAFTS = 'DRAFTS',

  /**
   * AKCE: Nový spis
   */
  CREATE_INF_FILE_BUTTON = 'CREATE_INF_FILE_BUTTON',

  /**
   * AKCE: Upravit spis
   */
  UPDATE_INF_FILE_BUTTON = 'UPDATE_INF_FILE_BUTTON',

  /**
   * AKCE: Smazat spis
   */
  DELETE_INF_FILE_BUTTON = 'DELETE_INF_FILE_BUTTON',

  /**
   * AKCE: Změnit agendu
   */
  UPDATE_INF_FILE_AGENDA_BUTTON = 'UPDATE_INF_FILE_AGENDA_BUTTON',

  /**
   * AKCE: Změnit stav
   */
  UPDATE_INF_FILE_STATE_BUTTON = 'UPDATE_INF_FILE_STATE_BUTTON',

  /**
   * AKCE: Obal spisu
   */
  CREATE_FILE_COVER_BUTTON = 'CREATE_FILE_COVER_BUTTON',

  /**
   * AKCE: Znovu otevřít
   */
  REOPEN_INF_FILE_BUTTON = 'REOPEN_INF_FILE_BUTTON',
}

export default Element;
